import { AnalysesClient, ExportSelectedDataRequest, ExportSelectedDataResponse, ProjectData } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { useMutation, useQuery } from "@tanstack/react-query";

const analysesClient = new AnalysesClient(undefined, axios);

export const useProjectData = (projectId: string | undefined, options?: any) => {
  return useQuery<ProjectData | null>({
    ...options,
    queryKey: ["projectData", projectId],
    queryFn: async () => projectId ? analysesClient.getProjectData(projectId!) : new Promise((resolve) => resolve(null)),
    // TODO: before we can enable caching here, we need to ensure that any mutations (create, delete, update) properly invalidate or update the cache
    //staleTime: 30 * 60 * 1000, // 30 minutes
    //cacheTime: 60 * 60 * 1000, // 60 minutes       
  });
};

export const useExportProjectData = (projectId: string | undefined, options?: any) => {
  return useMutation<ExportSelectedDataResponse | null, unknown, ExportSelectedDataRequest>({
    ...options,
    mutationFn: async (exportSelectedDataRequest: ExportSelectedDataRequest) =>
      projectId ? analysesClient.exportSelectedData(projectId!, exportSelectedDataRequest) : new Promise((resolve) => resolve(null)),
  });
};

export const useExportMultiProjectData = (options?: any) => {
  return useMutation<ExportSelectedDataResponse | null, unknown, string[]>({
    ...options,
    mutationFn: async (projectIds: string[]) => analysesClient.exportMultiProjectData(projectIds),
  });
};